module.exports = __webpack_public_path__ + "img/active-gztiao.2a68089b.png";